/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Skeleton,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr
} from '@chakra-ui/react'
import React, { useCallback, useEffect, useState } from 'react'
import { FiEdit } from 'react-icons/fi'

import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useQuery } from 'react-query'
import { NotFound } from '../../components/molecules/NotFound'
import { Pagination } from '../../components/PaginationNew'
import { PermissionComponent } from '../../components/Permissions'
import { useAuth } from '../../hooks/auth'
import { getTemplates, useTemplates } from '../../hooks/templates/useTemplates'
import { LayoutList } from '../../layouts/List'

// debounce
let timer: any = null

export function DocumentPrint() {
  const { clinicId } = useAuth()
  const [t] = useTranslation('pageDocumentPrint')
  const [searchState, setSearchState] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [isActive, setIsActive] = useState(true)
  const skeletonRepeat = [1, 2, 3, 4, 5, 6, 7]

  const {
    data: getTemplatesData,
    isFetching,
    refetch,
    isLoading
  } = useQuery(
    ['templates', String(clinicId), currentPage, searchState, isActive],
    () => getTemplates(String(clinicId), currentPage, searchState, isActive)
  )

  useEffect(() => {
    refetch()
  }, [])

  const SearchInputCallbackValue = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      const { value } = event.currentTarget

      clearTimeout(timer)

      timer = setTimeout(() => {
        setCurrentPage(1)
        setSearchState(value)
      }, 500)
    },
    []
  )

  const ActiveCheckboxCallbackValue = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setIsActive(event.target.checked)
    },
    []
  )

  return (
    <LayoutList
      title={t('title')}
      urlNew="/settings/template/create"
      refetch={refetch}
      isFetching={isFetching}
      placeholder={t('search')}
      capturaChange={(event: any) => SearchInputCallbackValue(event)}
      captureActiveChange={(event: any) => ActiveCheckboxCallbackValue(event)}
      spiCode="PRESCRIPTIONS"
    >
      <Box>
        <Table variant="striped" colorScheme="blue" size="sm">
          <Thead>
            <Tr>
              <Th>{t('t1')}</Th>
              <Th>{t('t3')}</Th>
              <Th>{t('t4')}</Th>
            </Tr>
          </Thead>
          <Tbody>
            {isLoading ? (
              <>
                {skeletonRepeat?.map((skeleton) => (
                  <Tr key={skeleton}>
                    <Td>
                      <Skeleton height="20px" />
                    </Td>
                    <Td>
                      <Skeleton height="20px" />
                    </Td>
                    <Td>
                      <Skeleton height="20px" />
                    </Td>
                    <Td>
                      <Skeleton height="20px" />
                    </Td>
                    <Td>
                      <Skeleton height="20px" />
                    </Td>
                  </Tr>
                ))}
              </>
            ) : (
              <>
                {getTemplatesData?.templates.map((template) => (
                  <Tr key={template.id} maxHeight="40px">
                    <Td>
                      <Text fontSize="sm">{template.name}</Text>
                    </Td>

                    <Td>
                      <Text fontSize="sm">
                        {template.status === 1 && `${t('status.1')}`}
                        {template.status === 2 && `${t('status.2')}`}
                      </Text>
                    </Td>

                    <Td>
                      <PermissionComponent
                        spiCode="PRESCRIPTIONS"
                        ipCode="EDIT"
                      >
                        <Link
                          to={{
                            pathname: `/settings/template/update/${template.id}`,
                            state: template
                          }}
                        >
                          <Tooltip
                            label="Editar"
                            aria-label="editar"
                            hasArrow
                            placement="top-start"
                          >
                            <Box ml="1rem" w="24px">
                              <FiEdit
                                color="#9699B0"
                                size={16}
                                style={{ cursor: 'pointer' }}
                              />
                            </Box>
                          </Tooltip>
                        </Link>
                      </PermissionComponent>
                    </Td>
                  </Tr>
                ))}
              </>
            )}
          </Tbody>
        </Table>
        {getTemplatesData?.totalCountOfPage === 0 && !isLoading && <NotFound />}
      </Box>
      {!(getTemplatesData?.totalCountOfPage === 0 && !isLoading) && (
        <Pagination
          totalCountOfRegisters={getTemplatesData?.totalCountOfPage || 0}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
        />
      )}
    </LayoutList>
  )
}
